<template>
  <div class="info">
    <Hero
      class="hero"
      heading="Visual Identity"
      :heroOverlay="'lightOverlay'"
    />
    <TextBlock title="Our Visual Identity">
      <p>
        Our visual identity is much more than just a logotype.
        It's a system of colors, typography and ideas that together,
        create a unique and distinct impression that manifests
        what we stand for and how we want to be perceived. On this
        portal, you'll find all the assets and guides to manage the
        brand identity in your daily job.
      </p>
    </TextBlock>
    <PageContainer>
      <ViContainer>
        <ViBox
          title="logo"
          :visualIdBox="'vi-logo.svg'"
          to="/identity/logotype"
        />
        <ViBox
          title="pixel head"
          :visualIdBox="'vi-pixel-head.svg'"
          to="/identity/pixel-head"
        />
        <ViBox
          title="fonts"
          :visualIdBox="'vi-font.svg'"
          to="/identity/typography"
        />
        <ViBox
          title="colors"
          :visualIdBox="'vi-color.svg'"
          to="/identity/colors"
        />
        <ViBox
          title="templates"
          :visualIdBox="'vi-template.svg'"
          to="/identity/templates"
        />
        <ViBox
          title="images"
          :visualIdBox="'vi-image.svg'"
          to="/identity/images"
        />
        <ViBox
          title="videos"
          :visualIdBox="'vi-video.svg'"
          to="/identity/videos"
        />
        <ViBox
          title="icons"
          :visualIdBox="'vi-icon.svg'"
          to="/identity/icons"
        />
        <ViBox
          title=""
          :visualIdBox="'vi-guidelines.svg'"
          url="https://seenthis.co/information/visual-identity/brand-guidelines.pdf"
        />
      </ViContainer>
    </PageContainer>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import TextBlock from '../components/text-block.vue';
import PageContainer from '../components/page-container.vue';
import ViContainer from '../components/visual-id-container.vue';
import ViBox from '../components/visual-id-box.vue';

export default {
  name: 'Info',
  components: {
    Hero,
    TextBlock,
    PageContainer,
    ViContainer,
    ViBox,
  },
};
</script>
